import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  Badge,
  Button,
  Input,
  InputGroup,
  Alert,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TestimonialService from "../../../services/KangarooServices/TestimonialService";
import toast from "react-hot-toast";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import img from "../../../../src/assets/images/users/user-dummy-img.jpg";
import "bootstrap-icons/font/bootstrap-icons.css";
import DeleteModal from "../../../Components/Common/DeleteModal";
import TestimonialDetail from "../Component/TestimonialDetail";
import { imageBaseApi } from "../../../utilis/imageHelper";

const Testimonial = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ismodalOpen, setIsModalOpen] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const toggleDetailModal = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setIsModalOpen(!ismodalOpen);
  };

  const fetchdetail = async () => {
    try {
      const response = await TestimonialService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchdetail();
  }, []);

  const filteredTestimonials = data.filter(
    (t) =>
      t.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.courseName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await TestimonialService.delete(selectedDeleteItem);
        fetchdetail();
        toast.success("Testimonial deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <i
        key={i}
        className={`bi ${
          i < rating ? "bi-star-fill text-warning" : "bi-star text-muted"
        }`}
        style={{ fontSize: "0.9rem", marginRight: "3px" }}
      ></i>
    ));
  };
  console.log(filteredTestimonials);

  return (
    <div className="page-content">
      <Container fluid className="">
        <BreadCrumb title="Testimonial" pageTitle="Location & Affiliation" />

        {/* Header Section */}
        <Row className="g-4 mb-4">
          <Col className="col-sm-auto">
            <button
              className="btn btn-success"
              color="primary"
              onClick={() => navigate("/testimonialform")}
            >
              <i className="ri-add-line align-bottom me-1"></i>
              Add Testimonial
            </button>
          </Col>
          <Col className="col-sm">
            <div className="d-md-flex justify-content-sm-end gap-2">
              <div className="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                <Input
                  type="text"
                  className="form-control"
                  id="searchJob"
                  autoComplete="off"
                  placeholder="Search by name or course"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="ri-search-line search-icon"></i>
              </div>
            </div>
          </Col>
        </Row>

        {/* Testimonial Cards */}
        <Row xs="1" md="2" lg="3" className="g-4">
          {filteredTestimonials.map((testimonial) => (
            <Col key={testimonial.id}>
              <Card className="border-0 shadow-sm h-100 overflow-hidden hover-lift">
                <CardBody className="d-flex flex-column p-4">
                  {/* Header with Image and Name */}
                  <div className="d-flex align-items-start mb-3">
                    <div className="flex-shrink-0 position-relative">
                      <div
                        className="avatar-lg rounded-circle shadow-sm position-relative overflow-hidden border border-2 border-light"
                        style={{ width: "70px", height: "70px" }}
                      >
                        <img
                          src={`${imageBaseApi}${testimonial?.studentPhoto?.url}`}
                          alt={testimonial.studentName}
                          className="w-100 h-100"
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                      {testimonial.isFeatured && (
                        <div
                          className="position-absolute bottom-0 end-0 bg-success rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: "24px",
                            height: "24px",
                            border: "2px solid white",
                          }}
                        >
                          <i
                            className="ri-star-fill text-white"
                            style={{ fontSize: "0.7rem" }}
                          ></i>
                        </div>
                      )}
                    </div>

                    <div className="flex-grow-1 ms-3 overflow-hidden">
                      <div className="d-flex justify-content-between align-items-start mb-1">
                        <Link
                          to={`/testimonial-detail/${testimonial.id}`}
                          className="text-decoration-none"
                        >
                          <h5 className="mb-0 text-dark fw-semibold d-flex align-items-center">
                            <span className="text-truncate">
                              {testimonial.studentName}
                            </span>
                            <i className="ri-external-link-line text-muted fs-6 ms-2 flex-shrink-0"></i>
                          </h5>
                        </Link>
                      </div>

                      <div className="d-flex flex-wrap align-items-center gap-2">
                        <small className="text-muted d-flex align-items-center">
                          <i className="ri-book-line me-1 text-primary"></i>
                          <span className="text-truncate">
                            {testimonial.courseName}
                          </span>
                        </small>
                      </div>

                      <div className="mt-2">
                        <Badge
                          color={testimonial.isFeatured ? "success" : "light"}
                          className={`${
                            testimonial.isFeatured ? "" : "text-dark border"
                          } d-inline-flex align-items-center px-2 py-1 fw-medium`}
                        >
                          <i
                            className={`${
                              testimonial.isFeatured
                                ? "ri-star-fill"
                                : "ri-star-line"
                            } me-1`}
                          ></i>
                          {testimonial.isFeatured ? "Featured" : "Not Featured"}
                        </Badge>
                      </div>
                    </div>
                  </div>

                  {/* Quote Icon and Content */}
                  <div className="flex-grow-1 position-relative">
                    <div className="position-relative bg-light rounded p-3 mb-3">
                      <CardText
                        className="text-muted fst-italic mb-0 position-relative"
                        style={{ paddingLeft: "24px", lineHeight: "1.6" }}
                      >
                        {testimonial?.text?.length > 1
                          ? `${testimonial?.text.substring(0, 80)}...`
                          : testimonial.content}
                      </CardText>
                    </div>
                  </div>

                  {/* Footer with Stars and Actions */}
                  <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                    <div className="d-flex align-items-center">
                      {renderStars(testimonial.rating)}
                      <span className="ms-2 small text-muted fw-medium">
                        ({testimonial.rating}/5)
                      </span>
                    </div>

                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="btn-soft-warning d-inline-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                        onClick={() =>
                          navigate(`/testimonialform/update/${testimonial?.id}`)
                        }
                      >
                        <i className="bx bx-edit-alt fs-6"></i>
                      </Button>

                      <Button
                        size="sm"
                        color="danger"
                        className="btn-soft-danger d-inline-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                        onClick={() => handleDeleteClick(testimonial.id)}
                      >
                        <i className="ri-delete-bin-5-line fs-6" />
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {filteredTestimonials.length === 0 && (
          <Alert color="info" className="text-center my-5 border-0 shadow-sm">
            <i className="ri-information-line fs-1 text-info mb-3 d-block"></i>
            <h4 className="mb-2">No testimonials found</h4>
            <p className="text-muted mb-0">
              Try adjusting your search terms or add a new testimonial
            </p>
          </Alert>
        )}

        <TestimonialDetail
          isOpen={ismodalOpen}
          toggle={toggleDetailModal}
          selectedTestimonial={selectedTestimonial}
        />
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default Testimonial;
